import { getTimeMs } from "TimeHelper";
import { ListMatchTeam } from "./ListMatchTeam";
import { MatchTeamsContainer } from "./styles";
import { matchHasStarted } from "model/Match/MatchStatus";
import { Match } from "model/Match/Match";
import { getRosterIdOrPlaceholder } from "model/Roster/Roster";

interface Props {
  match: Match;
  tournamentId: string;
  showTrackScores: boolean;
}

export const MatchTeamsList = ({
  match,
  tournamentId,
  showTrackScores,
}: Props) => {
  // todo - extract to reusable method, e.g. logic to show scores is used in other places too
  const showScores =
    !match.isDelayed &&
    (match.startTimeMs < getTimeMs() ||
      matchHasStarted(match) ||
      match.isComplete);

  return (
    <MatchTeamsContainer>
      {match.teams.rosters.map((roster, i) => (
        <ListMatchTeam
          key={`${getRosterIdOrPlaceholder(roster)}-${i}`}
          match={match}
          roster={roster}
          tournamentId={tournamentId}
          showScores={showScores}
          showTrackScores={showTrackScores}
        />
      ))}
    </MatchTeamsContainer>
  );
};
